// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.expandDiv {
    width: 24px;
    height: 24px;
}

.settingsTable td {
    padding-top: 0px;
    padding-bottom: 0px;
}

.actionRow button {
    width: 30px;
    height: 30px;
    line-height: 30px;
}
`, "",{"version":3,"sources":["webpack://./src/app/settings/datamodel/containerbusinessmodel/containerbusinessmodel.settings.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB","sourcesContent":[".expandDiv {\n    width: 24px;\n    height: 24px;\n}\n\n.settingsTable td {\n    padding-top: 0px;\n    padding-bottom: 0px;\n}\n\n.actionRow button {\n    width: 30px;\n    height: 30px;\n    line-height: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
